import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Link } from 'react-router-dom';
import { Routes } from 'constants/pages';
import { Pack } from 'types/Billing';
import { Permission, useHasPermission } from 'utils/permissions';
import { BUTTON_ACTIONS } from './constants';
import { MarketingPricingCard } from './MarketingPricingCard';
import { getPacks } from '../../../services/clients/subscription';

const fetchPacks = async () => {
  const packs: Pack[] = await getPacks();
  return packs;
};

interface Props {
  selectedPack: Pack;
  onPackSelected: (packId: string, name: string) => void;
}

const CheckoutStatus: React.FC<Props> = ({ selectedPack, onPackSelected }) => {
  const [packs, setPacks] = useState<Pack[]>([]);
  const hasShippersWatchlist = useHasPermission([Permission.ShipmentWatchList]);

  useEffect(() => {
    const getUpdatedPacks = async () => {
      setPacks(await fetchPacks());
    };
    getUpdatedPacks();
    // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ctaTo = hasShippersWatchlist ? Routes.Shipments : Routes.ContainerTracking;

  return (
    <>
      <div className="flex flex-col space-y-8 items-start">
        <div className="flex flex-col">
          <h1 style={{ fontSize: '36px' }} className="font-bold">
            You have successfully subscribed to a {selectedPack.displayName}
          </h1>
          <h2 className="font-medium text-dark mt-8">Thank you for your subscription!</h2>
        </div>
        <div className="flex space-x-4">
          <Link to={ctaTo}>
            <Button variant="contained" color="primary" size="medium">
              <p className="font-bold">
                Track your containers <ArrowRightAltIcon sx={{ fontSize: 17 }} />
              </p>
            </Button>
          </Link>
          <Link to={Routes.Profile}>
            <Button variant="outlined" color="primary" size="medium">
              <p className="font-bold">Invite team members</p>
            </Button>
          </Link>
        </div>
      </div>
      <div className="flex flex-col space-y-8 mt-16">
        <h1 className="font-bold text-gray-900">It&apos;s not too late to upgrade your plan!</h1>
        <div className="flex space-x-4">
          {packs
            .filter((p) =>
              [BUTTON_ACTIONS.UPGRADE, BUTTON_ACTIONS.CONTACT_US].includes(p.buttonText)
            )
            .map((p) => (
              <React.Fragment key={p.id}>
                <MarketingPricingCard
                  name={p.displayName}
                  title={p.title}
                  subtitle={p.subtitle}
                  onPackSelected={() => onPackSelected(p.id, p.buttonText)}
                  displayedColor={p.displayedColor}
                />
              </React.Fragment>
            ))}
        </div>
      </div>
    </>
  );
};
CheckoutStatus.displayName = 'CheckoutStatus';

export default CheckoutStatus;
